<template>
  <div>
    <b-overlay :show="processing" rounded="sm" class="overlay-display">
      <template #overlay>
        <div class="text-center">
          <b-spinner type="grow" variant="info" label="Loading..."></b-spinner>
          <p id="cancel-label">Please wait...</p>
        </div>
      </template>
      <ErrorAlert
        :show="alert.error"
        :message="alert.message"
        @hide-alert="hideError"
      />
      <SuccessAlert
        :show="alert.success"
        :message="alert.message"
        @hide-alert="hideSuccess"
      />
      <h2><strong>Reset Password for Customer</strong></h2>
      <div class="flex" style="margin-top: 1rem;">
        <b-form-input
          v-model="email"
          type="text"
          placeholder="Customer Email"
          class="input-height mt-1"
        ></b-form-input>
        <b-button
          style="margin-top: 0.5rem;"
          type="submit"
          variant="primary"
          class="form-submit-button submit-button"
          :disabled="email && email.trim() === ''"
          @click="resetPassword"
          >Submit</b-button
        >
      </div>
    </b-overlay>
  </div>
</template>

<script>
const ENDPOINT = process.env.VUE_APP_API_ADMIN_API_ENDPOINT;
import ErrorAlert from "@/components/alerts/error.vue";
import SuccessAlert from "@/components/alerts/success.vue";

export default {
  data() {
    return {
      processing: false,
      email: "",
      alert: {
        message: "",
        error: false,
        success: false
      }
    };
  },
  components: {
    ErrorAlert,
    SuccessAlert
  },
  methods: {
    async resetPassword() {
      this.processing = true;
      const res = await this.axios.post(
        ENDPOINT + "/customer/password/reset",
        JSON.stringify({ email: this.email }),
        {
          headers: {
            Authorization: "Bearer " + this.$store.getters.idToken
          }
        }
      );
      if (res.status === 200) {
        this.alert.message = "Success: Reset password email sent to: " + this.email;
        this.alert.success = true;
        this.alert.error = false;
        this.email = "";

      } else {
        this.alert.message = "Error: failed to reset password for: " + this.email;
        this.alert.success = false;
        this.alert.error = true;
      }
      this.processing = false;
    }
  }
};
</script>
